import apiClient from "../apiClient";

export const addNewRole = async (roleData) => {
  try {
    const response = await apiClient.post("roles/create", roleData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const updateRole = async ({ id, roleData }) => {
  try {
    const response = await apiClient.post("roles/update", roleData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getAllRolesAPI = async () => {
  try {
    const response = await apiClient.get("roles/getRoles");
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};
